import { useEffect } from "react";
import isBoolean from "lodash/isBoolean";
import { usePrevious } from "../../../../../utils/hooks/usePrevious";
import { SubText } from "../../../../../utils/auditorPeriod";
import { INVESTIGATOR_AUDITOR, INVESTIGATOR_CO_AUDITOR } from "./config";

export { checkActiveAuditorPeriod } from "../../../../../utils/auditorPeriod";

const getUserCompany = (user) => {
  if (user.auditor) return user.auditor.company || "-";
  if (user.company) return user.company.name;
  return "-";
};

export const prepareUserProperties = (user) => {
  let company = getUserCompany(user);
  let auditeeCompany = user?.auditeeCompany?.name;

  return {
    ...user,
    company,
    value: user.id,
    text: user.name,
    auditee_company: auditeeCompany,
    subText: <SubText company={company} />,
    subTextAuditee: <SubText company={auditeeCompany} />
  };
};

export const prepareInvestigatorData = (investigator) => {
  let desc = investigator.company_id;
  let systemAccess = !!investigator.auditor || !!investigator.user_id;

  if (investigator.type === INVESTIGATOR_CO_AUDITOR || investigator.type === INVESTIGATOR_AUDITOR) {
    desc = investigator.company_id;
  }

  return { ...investigator, desc, systemAccess };
};

export const getAvailableInvestigators = (users, report) => {
  const { lead = {}, coAuditors = [] } = report;
  const excludedIds = new Set([lead?.id, ...(coAuditors || []).map((item) => item.id)]);
  return (
    users?.filter((user) => {
      return !excludedIds.has(user.id);
    }) || []
  );
};

export const useClearInvestigatorSelect = (value, callback) => {
  const activity = {};
  const previousShouldResetinvestigatorSelect = usePrevious(activity.shouldResetinvestigatorSelect);

  useEffect(() => {
    if (
      value &&
      isBoolean(activity.shouldResetinvestigatorSelect) &&
      activity.shouldResetinvestigatorSelect !== previousShouldResetinvestigatorSelect
    ) {
      callback(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activity.shouldResetinvestigatorSelect]);
};
